<template>
  <app-layout title="Builder">
    <PageTitle :headerTitle="title"> </PageTitle>

    <div class="py-4">
      <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
        <div class="overflow-hidden sm:rounded-lg">

          <div class="grid  grid-cols-10 break-words gap-2 mt-2">

            <div class="bg-white rounded-md card-style">
              <jet-responsive-nav-link @click="goToModuleProduct">
                <i
                  class="fas fa-file-import fa-2x icon-center mt-2"
                  aria-hidden="true"
                ></i>
                <br />

                <div class="text-center leading-4">Product</div>
              </jet-responsive-nav-link>
            </div>

            <div class="bg-white rounded-md card-style">
              <jet-responsive-nav-link @click="goToModuleBuilder">
                <i
                  class="fas fa-file-import fa-2x icon-center mt-2"
                  aria-hidden="true"
                ></i>
                <br />

                <div class="text-center leading-4">Module</div>
              </jet-responsive-nav-link>
            </div>

            <div class="bg-white rounded-md card-style">
              <jet-responsive-nav-link>
                <i
                  class="fas fa-file-import fa-2x icon-center mt-2"
                  aria-hidden="true"
                ></i>
                <br />

                <div class="text-center leading-4">Tenant</div>
              </jet-responsive-nav-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </app-layout>
</template>

<style>
.card-style {
  min-height: 70px;
}

.icon-center {
  text-align: center;
  width: 100%;
}


</style>

<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import PageTitle from "@/Layouts/PageTitle.vue";
import JetResponsiveNavLink from "@/Jetstream/ResponsiveNavLink.vue";
let collapsed = false;


export default {
  props: {
    modules: Array,
    moduleRoute: String,
  },
  components: {
    AppLayout,
    PageTitle,
    JetResponsiveNavLink,
  },

  data() {
    return {
      title: "Builder",
    };
  },
  methods: {

    sayHelloWorld() {
      alert("Hello world!");
    },
    goToModuleBuilder() {
      this.$inertia.get("module");
    },
     goToModuleProduct() {
      this.$inertia.get("builders/product");
    },
    goToShow() {
      this.$inertia.get(this.moduleRoute + "/show");
    },
  },
   mounted() {
  },
};
</script>
